var _g, _path, _path2, _path3, _path4, _ellipse, _ellipse2, _path5, _path6, _path7, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _path8, _path9, _path0, _path1, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgIllustrationNotFound = function SvgIllustrationNotFound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 193 218"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration-not-found_svg__a)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 88,
    cy: 207.149,
    fill: "#E9E7F6",
    rx: 82,
    ry: 7
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-not-found_svg__b)",
    d: "M154.241 65.58s6.801 49.936 6.801 84.92c0 12.569-.362 56.265-22.119 56.265H20.5S40.5 202 40.5 154s-8.523-90.84-8.523-103.67c0-12.83 6.855-15.314 15.314-15.314h113.223c.177 0 .354.01.528.029-.187.09-6.801 3.377-6.801 30.535"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-not-found_svg__c)",
    d: "M161.045 35.045h-.003c-.187.09-6.801 3.378-6.801 30.535 1.832.448 5.194.232 6.273.239 6.553.048 8.497-6.898 8.497-15.402 0-10.616-3.522-14.876-7.966-15.372"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-not-found_svg__d)",
    d: "M18.678 181.488h115.229s-2.673 5.986-2.631 12.665c.045 8.037 1.98 12.561 7.647 12.612 11.76.11-118.352 0-118.352 0s-11.157-8.697-1.893-25.277"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#E4EDFF",
    d: "m98.21 134.593-13.231.759c-.172-3.681-.032-6.784.418-9.311.448-2.565 1.306-4.916 2.572-7.052 1.306-2.139 3.06-4.422 5.263-6.85a144.306 144.306 0 0 0 4.642-5.208c1.373-1.666 2.445-3.394 3.215-5.184.768-1.83 1.087-3.892.955-6.187-.143-2.492-.68-4.584-1.61-6.277-.93-1.693-2.233-2.948-3.907-3.765-1.634-.819-3.638-1.16-6.011-1.024-1.978.113-3.815.615-5.51 1.506-1.697.852-3.034 2.119-4.009 3.802-.977 1.643-1.43 3.773-1.36 6.388l-14.3.82c-.206-4.989.74-9.25 2.84-12.783 2.099-3.533 5.038-6.262 8.817-8.185 3.779-1.923 8.061-3.022 12.848-3.296 5.3-.304 9.882.346 13.744 1.95 3.86 1.564 6.877 4.01 9.053 7.339 2.212 3.286 3.457 7.342 3.733 12.168.2 3.48-.311 6.685-1.532 9.612-1.223 2.888-2.872 5.622-4.947 8.202a137.546 137.546 0 0 1-6.764 7.65c-2.1 2.144-3.477 4.426-4.132 6.845-.657 2.379-.92 5.073-.787 8.081m-13.357 19.34c-.122-2.136.506-3.978 1.886-5.526 1.377-1.587 3.332-2.453 5.864-2.598 2.531-.145 4.572.492 6.122 1.911 1.547 1.38 2.382 3.138 2.505 5.274.122 2.136-.505 3.997-1.883 5.584-1.38 1.548-3.335 2.394-5.867 2.539-2.531.145-4.57-.472-6.118-1.851-1.55-1.42-2.386-3.197-2.509-5.333",
    opacity: 0.5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.25,
    cy: 23.256,
    fill: "url(#illustration-not-found_svg__e)",
    rx: 5.25,
    ry: 5.256
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 185.25,
    cy: 95.256,
    fill: "url(#illustration-not-found_svg__f)",
    rx: 5.25,
    ry: 5.256
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-not-found_svg__g)",
    strokeWidth: 1.314,
    d: "M183.843 36.256c0 2.541-2.057 4.6-4.593 4.6a4.596 4.596 0 0 1-4.593-4.6c0-2.54 2.057-4.599 4.593-4.599a4.596 4.596 0 0 1 4.593 4.6Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-not-found_svg__h)",
    strokeWidth: 1.314,
    d: "M19.843 68.256c0 2.541-2.057 4.6-4.593 4.6a4.596 4.596 0 0 1-4.593-4.6c0-2.54 2.057-4.599 4.593-4.599a4.596 4.596 0 0 1 4.593 4.6Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-not-found_svg__i)",
    strokeWidth: 1.314,
    d: "M86.843 5.256c0 2.541-2.057 4.6-4.593 4.6a4.596 4.596 0 0 1-4.593-4.6c0-2.54 2.057-4.599 4.593-4.599a4.596 4.596 0 0 1 4.593 4.6Z"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.625,
    cy: 17.628,
    fill: "url(#illustration-not-found_svg__j)",
    rx: 2.625,
    ry: 2.628
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.625,
    cy: 60.628,
    fill: "url(#illustration-not-found_svg__k)",
    rx: 2.625,
    ry: 2.628
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 117.625,
    cy: 12.628,
    fill: "url(#illustration-not-found_svg__l)",
    rx: 2.625,
    ry: 2.628
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 189.625,
    cy: 44.628,
    fill: "url(#illustration-not-found_svg__m)",
    rx: 2.625,
    ry: 2.628
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 165.406,
    cy: 106.407,
    fill: "url(#illustration-not-found_svg__n)",
    rx: 1.932,
    ry: 1.934
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-not-found_svg__o)",
    strokeWidth: 1.314,
    d: "M165.093 88.047a1.97 1.97 0 0 1-1.968 1.971 1.97 1.97 0 0 1-1.968-1.97 1.97 1.97 0 0 1 1.968-1.972 1.97 1.97 0 0 1 1.968 1.971Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-not-found_svg__p)",
    strokeWidth: 1.314,
    d: "M96.593 22.628a1.97 1.97 0 0 1-1.968 1.971 1.97 1.97 0 0 1-1.968-1.97 1.97 1.97 0 0 1 1.968-1.972 1.97 1.97 0 0 1 1.968 1.971Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-not-found_svg__q)",
    fillRule: "evenodd",
    d: "M182.086 71.544a.57.57 0 0 0-1.142-.003l-.004 1.486-1.483-.005a.571.571 0 0 0-.004 1.143l1.483.004-.004 1.487a.57.57 0 1 0 1.141.003l.005-1.486 1.483.004a.572.572 0 0 0 .003-1.142l-1.483-.005z",
    clipRule: "evenodd"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-not-found_svg__r)",
    fillRule: "evenodd",
    d: "M22.678 42.919a.656.656 0 1 0-1.314.02l.05 3.604-3.267.049a.658.658 0 0 0 .018 1.313l3.267-.049.04 2.961a.656.656 0 1 0 1.314-.02l-.04-2.96 3.298-.05a.658.658 0 0 0-.018-1.313l-3.299.05z",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-not-found_svg__s)",
    fillRule: "evenodd",
    d: "M5.678 91.919a.656.656 0 1 0-1.314.02l.05 3.604-3.267.049a.658.658 0 0 0 .018 1.313l3.267-.049.04 2.961a.656.656 0 1 0 1.314-.02l-.04-2.96 3.298-.05a.658.658 0 0 0-.018-1.313l-3.299.05z",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-not-found_svg__t)",
    fillRule: "evenodd",
    d: "M140.678 15.919a.658.658 0 0 0-1.314.02l.05 3.604-3.267.049a.658.658 0 0 0 .018 1.313l3.267-.049.041 2.961a.656.656 0 1 0 1.313-.02l-.041-2.96 3.299-.05a.658.658 0 0 0-.018-1.313l-3.299.05z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-not-found_svg__b",
    x1: 90.771,
    x2: 90.771,
    y1: 35.016,
    y2: 206.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F8FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#9FBCFF",
    stopOpacity: 0.531
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEEA73",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-not-found_svg__c",
    x1: 163.754,
    x2: 181.43,
    y1: 30.748,
    y2: 51.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F65E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948,
    stopColor: "#AEEA73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-not-found_svg__d",
    x1: 75.646,
    x2: -102.097,
    y1: 213.958,
    y2: -18.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-not-found_svg__e",
    x1: 62.108,
    x2: 24.207,
    y1: 31.478,
    y2: 21.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-not-found_svg__f",
    x1: 185.107,
    x2: 147.207,
    y1: 103.478,
    y2: 93.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-not-found_svg__g",
    x1: 179.107,
    x2: 141.207,
    y1: 44.478,
    y2: 34.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-not-found_svg__h",
    x1: 15.107,
    x2: -22.793,
    y1: 76.478,
    y2: 66.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-not-found_svg__i",
    x1: 82.108,
    x2: 44.207,
    y1: 13.478,
    y2: 3.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-not-found_svg__j",
    x1: 34.554,
    x2: 15.603,
    y1: 21.739,
    y2: 16.711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-not-found_svg__k",
    x1: 4.554,
    x2: -14.397,
    y1: 64.739,
    y2: 59.711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-not-found_svg__l",
    x1: 117.554,
    x2: 98.603,
    y1: 16.739,
    y2: 11.711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-not-found_svg__m",
    x1: 189.554,
    x2: 170.603,
    y1: 48.739,
    y2: 43.711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-not-found_svg__n",
    x1: 165.353,
    x2: 151.406,
    y1: 109.432,
    y2: 105.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-not-found_svg__o",
    x1: 163.054,
    x2: 144.103,
    y1: 92.158,
    y2: 87.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-not-found_svg__p",
    x1: 94.554,
    x2: 75.603,
    y1: 26.739,
    y2: 21.711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-not-found_svg__q",
    x1: 181.438,
    x2: 162.487,
    y1: 77.711,
    y2: 72.683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-not-found_svg__r",
    x1: 18.033,
    x2: 4.705,
    y1: 50.888,
    y2: 27.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-not-found_svg__s",
    x1: 1.033,
    x2: -12.295,
    y1: 99.888,
    y2: 76.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-not-found_svg__t",
    x1: 136.033,
    x2: 122.705,
    y1: 23.888,
    y2: 0.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration-not-found_svg__a",
    width: 171.421,
    height: 21.422,
    x: 2.289,
    y: 196.439,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_5679_6386",
    stdDeviation: 1.855
  })))));
};
var Memo = /*#__PURE__*/memo(SvgIllustrationNotFound);
export default Memo;